// A tree's QR code (encodes its public URL) with a PNG download. Used on the
// public tree page so anyone can scan/print it.

import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, QrCode } from "lucide-react";

export default function TreeQR({ url, treeId, size = 150 }) {
    const wrapRef = useRef(null);

    const download = () => {
        const canvas = wrapRef.current?.querySelector("canvas");
        if (!canvas) return;
        const link = document.createElement("a");
        link.download = `${treeId || "tree"}-qr.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
    };

    return (
        <div className="card-base bg-white p-5 flex flex-col items-center text-center">
            <div className="flex items-center gap-1.5 text-[0.7rem] tracking-[0.18em] uppercase text-seedh-brown font-semibold">
                <QrCode className="w-3.5 h-3.5" /> Scan this tree
            </div>
            <div ref={wrapRef} className="mt-4 bg-white p-2.5 rounded-xl border border-seedh-border">
                <QRCodeCanvas value={url} size={size} level="M" marginSize={2} />
            </div>
            <p className="text-[0.7rem] text-seedh-muted mt-4 max-w-[13rem] leading-relaxed">
                Point a phone camera here to open this tree's page.
            </p>
            <button
                onClick={download}
                className="mt-4 w-full text-xs font-medium rounded-full border border-seedh-border px-3 py-2 text-seedh-blue hover:bg-seedh-surface-blue transition-colors inline-flex items-center justify-center gap-1.5"
            >
                <Download className="w-3.5 h-3.5" /> Download PNG
            </button>
        </div>
    );
}
